<template>
  <q-item
    clickable
    :to="to"
    v-ripple
    :active="isActive || active"
    active-class="active"
    class="text-black rounded-borders flex items-center justify-center q-pa-md"
    role="listitem"
    style="min-height: 2.5rem"
  >
    <q-item-section avatar>
      <q-icon :size="isMobile ? 'sm' : '20px'" :name="icon">
        <slot />
      </q-icon>
    </q-item-section>
    <q-item-section class="q-ml-sm" v-if="name">{{ name }} </q-item-section>
  </q-item>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DrawerItem',
  props: {
    to: {
      type: String,
      required: false,
    },
    matchPath: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
    },
    name: {
      type: String,
      required: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive() {
      return this.matchPath ? this.$route.path.includes(this.matchPath) : this.$route.path === this.to;
    },
  },
});
</script>

<script setup>
import { useMobile } from '@/hooks/useMobile';

const { isMobile } = useMobile();
</script>

<style lang="scss" scoped>
.active {
  background-color: #e3e3e3;
}
</style>
